/**
 * Account Details.
 *
 * The signed-in admin's own profile, password, and authentication settings -
 * one Canvas has exactly one of each, the same as System Settings. Every
 * "section" here (Profile Details, Choose a New Password, Authentication) is
 * an ordinary box on the page whose heading `expandExistingSection` can find
 * on its own, so there is nothing to resolve, filter, or focus-handle beyond
 * what `canvas.navigation` already does generically - this plugin declares
 * no fields either: chat only ever navigates to and highlights a control,
 * never fills one in, so password and 2FA fields are as safe to point at as
 * any other.
 */
const accountPlugin = {
	id: 'account',
	version: 1,
	commandVersion: 1,
	resource: 'account',
	operations: ['options', 'configure'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['account.dashboard'],
	},
};

export default accountPlugin;
